import steps from './steps';

// TODO: navigate through route name when all route were implemented.
export default {
  [steps.courseSelection]: '/selecao-de-curso',
  [steps.citySelection]: '/selecao-de-cidade',
  [steps.campusSelection]: '/selecao-de-polo',
  [steps.admissionType.selection]: '/forma-de-ingresso',
  [steps.admissionType.essay.themeSelection]: '/tema-de-redacao',
  [steps.admissionType.essay.supportText]: '/apoio-para-redacao',
  [steps.admissionType.essay.write]: '/envio-de-redacao',
  [steps.admissionType.enem.yearSelection]: '/selecao-de-ano-enem',
  [steps.admissionType.enem.subscriptionNumber]: '/inscricao-enem',
  [steps.admissionType.enem.grades]: '/notas-do-enem',
  [steps.admissionType.secondGraduation.institutionInfo]: '/dados-da-primeira-graduacao',
  [steps.admissionType.secondGraduation.documentation]: '/documentacao-da-primeira-graduacao',
  [steps.admissionType.transferGraduation.institutionInfo]: '/dados-de-transferencia',
  [steps.admissionType.transferGraduation.documentation]: '/documentacao-da-transferencia',
  [steps.retryEssay]: '/resultado',
  [steps.success]: '/resultado',
  [steps.failure]: '/resultado',
  [steps.pendingApproval]: '/resultado',
};
